import graphql__75413d6bb12fb4bdba16 from "./__generated__/AnswerRichText_answer.graphql.js";import { graphql, useFragment } from "react-relay";

import { useReadOnlyFieldProps } from "./useReadOnlyFieldProps";
import WysiwygField from "../Form/Field/WysiwygField";
import SimilarAnswersSuggestions from "../SimilarAnswers/SimilarAnswersSuggestions";

const AnswerRichText = function (props) {
  const answer = useFragment(AnswerRichText_answer, props.answer);

  const { content, contentAttachmentToken, formField } = answer;
  const { fieldName, label, required, hint, hintPosition } = formField;
  const { hide, disabled } = useReadOnlyFieldProps(formField);
  const { parent, resourceId } = props;

  return (
    <SimilarAnswersSuggestions answer={answer}>
      {handleValueChange => (
        <WysiwygField
          fieldName={fieldName}
          label={label}
          required={required}
          hint={hint}
          hintPosition={hintPosition}
          hide={hide}
          disabled={disabled}
          defaultValue={content}
          parent={parent}
          resourceId={resourceId}
          attachmentToken={contentAttachmentToken}
          onValueChange={handleValueChange}
        />
      )}
    </SimilarAnswersSuggestions>
  );
};

const AnswerRichText_answer = graphql__75413d6bb12fb4bdba16;

export default AnswerRichText;
